var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScalpPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32586 11.6719L4.16659 8.66839V7.996C4.16659 5.59758 5.63462 3.4436 7.86695 2.56662C9.23793 2.02802 10.7619 2.02802 12.1329 2.56662C14.3652 3.4436 15.8333 5.59758 15.8333 7.996V8.66839L15.674 11.6719C15.5342 14.3068 13.899 16.6292 11.4654 17.649C10.5279 18.0419 9.47192 18.0419 8.53439 17.649C6.10086 16.6292 4.46559 14.3068 4.32586 11.6719Z",
    stroke: "#939393",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667H9.16659",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8333H7.58333",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333H12.5833",
    stroke: "#939393",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34255 12.1836C2.71886 11.9964 2.29175 11.4224 2.29175 10.7712C2.29175 9.86978 3.09349 9.17933 3.98497 9.31305L4.37508 9.37157L4.37508 12.4933L3.34255 12.1836Z",
    stroke: "#939393",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6574 12.1836C17.2811 11.9964 17.7083 11.4224 17.7083 10.7712C17.7083 9.86978 16.9065 9.17933 16.015 9.31305L15.6249 9.37157L15.6249 12.4933L16.6574 12.1836Z",
    stroke: "#939393",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 8.69047V7.996C3.33325 5.25495 5.011 2.79326 7.56224 1.79099C9.12907 1.17545 10.8708 1.17545 12.4376 1.79099C14.9888 2.79326 16.6666 5.25495 16.6666 7.996V8.69047H3.33325Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalpPoint);
export default __webpack_public_path__ + "static/media/scalp-point.ef6c249f8d75ea26dbfdc4b11a281292.svg";
export { ForwardRef as ReactComponent };